<template>
  <a-card :bordered="false">

    <a-row :gutter="20">
      <a-col :span="userListShow?12:24">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">

              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="编码">
                  <a-input placeholder="请输入编码" v-model="queryParam.code"></a-input>
                </a-form-item>
              </a-col>

              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="名称">
                  <a-input placeholder="请输入名称" v-model="queryParam.name"></a-input>
                </a-form-item>
              </a-col>

              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px" v-has="'center:edit'">新增</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <!-- table区域-begin -->
        <div>
          <a-table
            ref="table"
            size="middle"

            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            class="j-table-force-nowrap"
            @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'center:edit'">编辑</a>
          <a-divider type="vertical" v-has="'center:edit'"/>
          <a @click="handleUserView(record)" v-has="'center:user'">用户</a>
          <a-divider type="vertical" v-has="'center:user'"/>
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'center:del'">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

          </a-table>
        </div>
      </a-col>
      <a-col :span="12" v-show="userListShow">
          <user-list ref="userList" :url="userUrl" :hidden-handle="hiddenHandle"></user-list>
      </a-col>
    </a-row>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <center-modal ref="modalForm" @ok="modalFormOk"></center-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import CenterModal from './modules/CenterModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import UserList from '../UserList'

  export default {
    name: "CenterList",
    mixins:[JeecgListMixin],
    components: {
      UserList,
      CenterModal
    },
    data () {
      return {
        userUrl:{
          list:'/sys/user/list',
          delete:'/sys/user/deleteCenter',
          add:'/sys/user/addCenter',
        },
        userListShow:false,
        userBaseQueryParam:{},
        description: '中心管理管理页面',
        // 表头
        columns: [
		      {
            title: '编码',
            align:"center",
            dataIndex: 'code'
          },
		      {
            title: '名称',
            align:"center",
            dataIndex: 'name'
          },
          {
            title: '上级中心',
            align:"center",
            dataIndex: 'parentName'
          },
		      {
            title: '中心管理员',
            align:"center",
            dataIndex: 'userName'
          },
          {
            title: '联系电话',
            align:"center",
            dataIndex: 'phone'
          },
          {
            title: '状态',
            align:"center",
            dataIndex: 'status_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/management/center/list",
          delete: "/management/center/delete",
       },
    }
  },
  computed: {
  },
    methods: {
      handleUserView(record){
        this.userBaseQueryParam = {
          centerId:record.id
        }
        this.userListShow = true
        this.$refs['userList'].view(this.userBaseQueryParam)
      },
      hiddenHandle(){
        this.userBaseQueryParam = {}
        this.userListShow = false
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>